<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QWS9GT/images/chi-Womack-cover.jpg?1724432671879" alt="This image is the cover for the book Matter of Black Living"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Matter of Black Living
      </h1>
      <p class="bookDescription body article font2">
        <b>Examining how turn-of-the-century Black cultural producers’ experiments with new technologies of racial data produced experimental aesthetics.</b><br/><br/> As the nineteenth century came to a close and questions concerning the future of African American life reached a fever pitch, many social scientists and reformers approached post-emancipation Black life as an empirical problem that could be systematically solved with the help of new technologies like the social survey, photography, and film. What ensued was nothing other than a “racial data revolution,” one which rendered African American life an inanimate object of inquiry in the name of social order and racial regulation. At the very same time, African American cultural producers and intellectuals such as W. E. B. Du Bois, Kelly Miller, Sutton Griggs, and Zora Neale Hurston staged their own kind of revolution, un-disciplining racial data in ways that captured the dynamism of Black social life.<br/><br/><i>The Matter of Black Living</i> excavates the dynamic interplay between racial data and Black aesthetic production that shaped late nineteenth-century social, cultural, and literary atmosphere. Through assembling previously overlooked archives and seemingly familiar texts, Womack shows how these artists and writers recalibrated the relationship between data and Black life. The result is a fresh and nuanced take on the history of documenting Blackness. <i>The Matter of Black Living</i> charts a new genealogy from which we can rethink the political and aesthetic work of racial data, a task that has never been more urgent.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Autumn Womack
      </h2>
      
      <p class="authorDescription body article"><B>Autumn Womack</B> is assistant professor of African American Studies and English at Princeton University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c6876a2